import addRoute from '@/router/add-route';

const WebsiteForm = () => import('@/modules/websites/website-form.vue');

const websites = [
    addRoute({
        name: 'add-website',
        path: '/websites/add/:organizationId/:continue?',
        component: WebsiteForm,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'update-website',
        path: '/websites/update/:id/:continue?',
        component: WebsiteForm,
        root: {label: 'Settings', name: 'settings'},
    }),
];

export default websites;
